package com.eladfinish.bible.contest.screens.mikud.model

import androidx.compose.runtime.Immutable

@Immutable
data class MikudSummaryModel(
    val totalChapters: Int,
    val books: List<BookSummaryModel>,
)

@Immutable
data class BookSummaryModel(
    val name: String,              // book.name (עברית)
    val includedChaptersCount: Int, // book.includedChaptersCount
    val chaptersText: String,       // "א״, ב״, ... .\n"
)
